import { AuthContextType } from '@auth/AuthProvider';
import NetworkController, { HTTPMethod, HTTPRequest, HTTPResponse } from '@data/controller/NetworkController';
import { ChurchStaff, StaffRole } from '@data/interfaces/church.interfaces';

// Church Hub accounts. All three calls are admin-only.
export default class StaffController {
  private static baseURL: string = process.env.REACT_APP_SANCTUARY_API_URL || "";

  // Creating the account emails them to set up a password. The API rejects an
  // email another staff account, at any church, already uses.
  static async inviteStaffMember(
    churchID: string,
    name: string,
    email: string,
    roles: StaffRole[],
    auth: AuthContextType
  ): Promise<HTTPResponse<ChurchStaff>> {
    return await NetworkController.performRequestAt<ChurchStaff>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.POST, `/v1/church/${churchID}/staff`, { name, email, roles }),
      auth.consumeRefreshToken
    );
  }

  // The API only takes a new name and roles; the email is their sign in and
  // can't change. It refuses to take away the requester's own Admin role.
  static async editStaffMember(
    churchID: string,
    staffID: string,
    name: string,
    roles: StaffRole[],
    auth: AuthContextType
  ): Promise<HTTPResponse<ChurchStaff>> {
    return await NetworkController.performRequestAt<ChurchStaff>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.PATCH, `/v1/church/${churchID}/staff/${staffID}`, { name, roles }),
      auth.consumeRefreshToken
    );
  }

  // The API refuses to delete an admin, or the requester themselves.
  static async deleteStaffMember(
    churchID: string,
    staffID: string,
    auth: AuthContextType
  ): Promise<HTTPResponse<unknown>> {
    return await NetworkController.performRequestAt<unknown>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.DELETE, `/v1/church/${churchID}/staff/${staffID}`),
      auth.consumeRefreshToken
    );
  }
}
